import { StateCreator } from 'zustand';
import { subscription, User } from '@/services/datatypes/auth';

export interface AuthZustandSlice {
    user: User | null;

    logout: () => void;
    updateUser: (userData: User) => void;
    updateSubscriptions: (subscriptions: subscription[]) => void;

    _hasHydrated: boolean;
    setHasHydrated: (state: any) => void;
}

export const createAuthZustandSlice: StateCreator<AuthZustandSlice> = (set, get) => ({
    user: null,
    session: null,

    logout: () => {
        set({ user: null });
    },
    updateUser: (userData: User) => set((state) => ({
        user: {
            ...userData,
            subscriptions: userData.subscriptions ?? state.user?.subscriptions ?? null,
        },
    })),
    updateSubscriptions: (subscriptions: subscription[]) => {
        const user = get().user;
        if (user) {
            set({
                user: {
                    ...user,
                    subscriptions,
                },
            });
        }
    },

    _hasHydrated: false,
    setHasHydrated: (state: any) => {
        set({
            _hasHydrated: state
        });
    },
});